import React from 'react';

const Description = () => {
    return(
        <div className="section">
            <div className="card z-depth-0">
                <div className="card-content">
                    <span className="card-title">Description :</span>
                    <p>The Firebase is a Backend-as-a-Service (BaaS) 
                        that offers the developers a wide spectrum of tools and services 
                        to develop high-quality apps at a much faster pace.
                        <br/>
                        - Real-time Database Helps to Store and Synchronize Data.<br/>
                        - Fast and Secured Web Hosting.<br/>
                        - Firebase Allows the Content Storage with Ease.<br/>
                        - Firebase Authentication.<br/>
                        - Developers have the Accessibility of Machine Learning.</p>
                </div>
            </div>
        </div>
    )
}

export default Description